var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import FadeIn from '../../../../components/Animation/FadeIn';
import FadeUp from '../../../../components/Animation/FadeUp';
import Button from '../../../../components/Button';
import { useWizard } from '../../../../hooks/useWizard';
import Heading from '../../../../components/Typography/Heading';
import { useValidation } from '../../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Paragraph from '../../../../components/Typography/Paragraph';
import FormRow from '../../../../components/Form/Row';
import TextArea from '../../../../components/Fields/TextArea';
import Select from '../../../../components/Fields/Select';
import { useOutletContext } from 'react-router-dom';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import ModalFull from '../../../../components/Modal/ModalFull';
import { Check } from '../../../../components/CustomIcon';
import Checkbox from '../../../../components/Fields/Checkbox';
import Location from '../../../../components/Fields/Location';
import JobsInput from '../../../../components/Fields/JobsInput';
import { usePlaceholder } from '../../../../hooks/usePlaceholder';
import TrueFalseInput from '../../../../components/Fields/TrueFalseInput';
var ProfessionalProfile = function () {
    var values = useOutletContext().values;
    var setValuesAndGoToNextStep = useWizard().setValuesAndGoToNextStep;
    var _a = useValidation(), arrayNullable = _a.arrayNullable, textRequired = _a.textRequired, textOptional = _a.textOptional, gdprRequired = _a.gdprRequired, locationRequired = _a.locationRequired, booleanNullable = _a.booleanNullable;
    var placeholders = usePlaceholder();
    var _b = useState(false), stepCompleted = _b[0], setStepCompleted = _b[1];
    var _c = useState([]), status = _c[0], setStatus = _c[1];
    var _d = useState([]), categories = _d[0], setCategories = _d[1];
    var _e = useState(3000), modalDuration = _e[0], setModalDuration = _e[1];
    useEffect(function () {
        if (!categories.length && !status.length) {
            axiosInstance.get(api.jobs.categories).then(function (_a) {
                var data = _a.data;
                setCategories(data);
                axiosInstance.get(api.professionalStatus.all).then(function (_a) {
                    var data = _a.data;
                    setStatus(data);
                });
            });
        }
    }, []);
    var schema = yup.object().shape({
        profile_title: textRequired,
        professional_status: textOptional,
        jobs: arrayNullable,
        custom_jobs: arrayNullable,
        sorted_jobs: arrayNullable,
        location: locationRequired,
        consent_gdpr: gdprRequired,
        display_professional_status: booleanNullable,
    });
    var _f = useForm({
        resolver: yupResolver(schema),
        defaultValues: values,
    }), handleSubmit = _f.handleSubmit, control = _f.control, setValue = _f.setValue, watch = _f.watch;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setStepCompleted(true);
            setTimeout(function () {
                setValuesAndGoToNextStep(data);
            }, modalDuration);
            return [2 /*return*/];
        });
    }); };
    return (<FadeIn>
      <div className="flex flex-col gap-10 py-10">
        <div>
          <Heading level={1} type="h4">
            S’inscrire sur Majeur·e·s
          </Heading>
          <Paragraph size="lg">Vos informations personnelles</Paragraph>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <FormRow>
              <TextArea label="Titre de votre profil" name="profile_title" placeholder={placeholders.profileTitle} control={control} required max={90} instructions="Indiquez un titre qui permet d’identifier facilement votre activité ou vos compétences."/>
            </FormRow>
            <FormRow>
              <Select label="Statut professionnel" name="professional_status" control={control} instructions="Multi-casquettes ? Choisissez le statut sous lequel vous souhaitez être référencé·e." choices={status}/>
            </FormRow>
            <FormRow>
              <TrueFalseInput label="Afficher sur mon profil" name="display_professional_status" control={control}/>
            </FormRow>
            <FormRow>
              <JobsInput name="jobs" control={control} categories={categories} custom={watch('custom_jobs')} handleCustom={function (value) {
            return setValue('custom_jobs', value);
        }} sorted={watch('sorted_jobs')} handleSorted={function (value) {
            return setValue('sorted_jobs', value);
        }}/>
            </FormRow>
            <FormRow>
              <Location label="Localisation" name="location" placeholder={placeholders.location} control={control} instructions="Indiquez la ville dans laquelle vous vivez en ce moment." required/>
            </FormRow>
            <FormRow>
              <Checkbox ariaLabel="En cochant cette case, j’accepte les conditions générales d’utilisation et la charte de confidentialité du site Majeur·e·s" name="consent_gdpr" control={control} required>
                En cochant cette case, j’accepte les conditions générales d’utilisation et la{' '}
                <span className="cursor-pointer font-medium text-brand-01 underline transition-colors hover:text-brand-02" onClick={function () { return (window.location.href = '/politique-de-confidentialite'); }}>
                  charte de confidentialité
                </span>{' '}
                du site Majeur·e·s
              </Checkbox>
            </FormRow>
            <Button submit className="sm:self-end">
              Enregistrer mes informations
            </Button>
          </div>
        </form>
      </div>
      <ModalFull open={stepCompleted} duration={modalDuration}>
        <FadeUp>
          <Check className="fill-white" size={86}/>
        </FadeUp>
        <FadeUp>
          <Heading level={1} type="h2" className="mt-6">
            C’est noté !
          </Heading>
        </FadeUp>
        <FadeUp>
          <Paragraph size="lg" className="mt-2">
            Continuons de remplir ensemble votre profil...
          </Paragraph>
        </FadeUp>
      </ModalFull>
    </FadeIn>);
};
export default ProfessionalProfile;
